export {
  INVOICE_RECIPIENT_FIELD_CODE,
  LEAVES_ALONE_FIELD_CODE,
  MIDDLE_NAME_FIELD_CODE,
  PARENT_PROFILE_FORM_GROUPS,
  PRIMARY_CONTACT_FIELD_CODE,
  SCHOOL_PLACEMENT_FIELD_CODES,
  STUDENT_PROFILE_FORM_GROUPS,
} from "./config/profileFormGroups";
export type {
  ProfileFormFieldDefinition,
  ProfileFormGroupDefinition,
  StandardProfileFieldKey,
} from "./config/profileFormGroups";

export {
  PROFILE_FIELD_DESCRIPTIONS,
  getProfileFieldDescription,
} from "./config/profileFieldDescriptions";

export {
  buildProfilePatch,
  createProfileFormValues,
  isProfileFormDirty,
} from "./lib/profileFormState";
export type { ProfileFormValues } from "./lib/profileFormState";

export {
  formatProfileSummary,
  formatReadonlyFieldSummary,
  getProfileLabel,
} from "./lib/formatProfileSummary";
export { getProfileBadge } from "./lib/getProfileBadge";

export { ProfileFormProvider } from "./context/ProfileFormProvider";
export { useProfileForm } from "./context/useProfileForm";
export { useConfirmDiscardUnsavedChanges } from "./hooks/useConfirmDiscardUnsavedChanges";

export { ProfileScreenLayout } from "./layout/ProfileScreenLayout";

export { ProfileForm } from "./form/ProfileForm";
export { ProfileFormActions } from "./form/ProfileFormActions";
export { ProfileFormGroup } from "./form/ProfileFormGroup";
export { RoleProfileForm } from "./form/RoleProfileForm";

export { FieldSelectionScreen } from "./selection/FieldSelectionScreen";

export { FamilyProfilesSection } from "./FamilyProfiles/FamilyProfilesSection";

export type { ProfileFormFieldHandlers } from "./types/profileFormFieldHandlers";
